export const isChipList = (data: any) => {
    for (const item of data) {
        if (item && typeof item !== 'object') {
            return true
        }
    }
    return false
}